export const PROFILE_ITEMS_PER_PAGE = 12;

function normalizeCount(value: number): number {
  if (!Number.isFinite(value)) {
    return 0;
  }
  return Math.max(0, Math.floor(value));
}

export function computeProfileTotalPages(visibleItemCount: number): number {
  const visibleCount = normalizeCount(visibleItemCount);
  return Math.max(1, Math.ceil(visibleCount / PROFILE_ITEMS_PER_PAGE));
}

export function computeProfileVisibleItemCount(
  filter: "all" | "wallet",
  ownedCount: number,
  nftCount: number
): number {
  const safeOwnedCount = normalizeCount(ownedCount);
  const safeNftCount = normalizeCount(nftCount);
  if (filter === "wallet") {
    return safeNftCount;
  }
  return safeOwnedCount + safeNftCount;
}
